import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../../helpers/translate service/language.service';
import { Router } from '@angular/router';
import { routeConfig } from '../../../shared/utilities/pages-config';

@Component({
  selector: 'app-covid',
  templateUrl: './covid.component.html',
  styleUrls: ['./covid.component.css']
})
export class CovidComponent implements OnInit {

  constructor(public languageService: LanguageService,
    private router: Router) { }

  ngOnInit() {
  }
  navigateToContactUs() {
    this.router.navigate([routeConfig.contact_us.route]);
  }
  navigateToOrder() {
    this.router.navigate([routeConfig.order.route]);
  }
  navigateToCompletedOrder() {
    this.router.navigate([routeConfig.order.completed.route]);
  }
  navigateToServices() {
    this.router.navigate([routeConfig.services.route]);
  }
  navigateToPrice() {
    this.router.navigate([routeConfig.prices.route]);
  }
}
